module.exports = __webpack_public_path__ + "img/1.dd8e4f90.jpg";